


















import { Component, Vue, Prop } from 'vue-property-decorator';


@Component
export default class ListBox extends Vue {
  @Prop({ required: true, default: () => [] })
  private data!: any[];
  @Prop({ default: false }) private spinning!: boolean;
}
